const footerLinks = [
  {
    title: '电影分类',
    links: ['动作片', '喜剧片', '科幻片', '爱情片', '恐怖片', '动画片', '纪录片'],
  },
  {
    title: '快速导航',
    links: ['热门推荐', '高分佳作', '新片速递', '经典回顾', '排行榜', '专题放映'],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '常见问题', '联系方式', '用户反馈', '合作伙伴'],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-movie-2-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-50 tracking-wide">
                8848<span className="text-accent-400">影院</span>
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4 max-w-[280px]">
              8848影院电影大全涵盖最新电影、经典电影、动作片、喜剧片等各类高清影片，免费在线观看，片源丰富即点即播。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 hover:text-accent-400 hover:bg-accent-500/10 transition-all cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 hover:text-accent-400 hover:bg-accent-500/10 transition-all cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-200 text-foreground-500 hover:text-accent-400 hover:bg-accent-500/10 transition-all cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col, idx) => (
            <div key={idx}>
              <h4 className="text-sm font-semibold text-foreground-300 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link, i) => (
                  <li key={i}>
                    <a
                      href="#hero"
                      className="text-sm text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/60 pt-6 mb-6">
          <h4 className="text-sm font-semibold text-foreground-300 mb-3">合作伙伴</h4>
          <p className="text-xs text-foreground-600">更多合作伙伴持续加入中，敬请期待。</p>
        </div>

        <div className="border-t border-background-200/60 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 8848影院. 本站所有内容仅供学习交流，请于24小时内删除。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-600">
              <span className="cursor-pointer hover:text-foreground-400 transition-colors">隐私政策</span>
              <span className="cursor-pointer hover:text-foreground-400 transition-colors">使用条款</span>
              <span className="cursor-pointer hover:text-foreground-400 transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}